const initialState = {
    data: {},
    loading: false,
    error: null
  };
  
  const userReducerGerCurrentSubMessage = (state = initialState, action) => {
    switch (action.type) {
      case 'GET_CURRENT_SUBMESSAGE_REQUEST':
        return {
          ...state,
          loading: true,
          error: null
        };
      case 'GET_CURRENT_SUBMESSAGESUCCESS':
    
        return {
          ...state,
          loading: false,
          data: action.payload
        };
        
      case 'GET_CURRENT_SUBMESSAGE_FAILURE':
        return {
          ...state,
          loading: false,
          error: action.payload
        };
      default:
        return state;
    }
  };
  
  export default userReducerGerCurrentSubMessage;
  